import styled from 'styled-components';

import { InquisitiveBorderStyle } from 'global/graphql/scalars.type';
import { ACTIVITIES_BASE_HEIGHT_SMALL } from 'global/constants';
import { rem } from 'approot/shared/style';
import { grey2, grey5 } from 'approot/shared/styles/colours.style';
import { useActivityBuilderFontStyles } from 'approot/activity-builder/theme/activity-builder-theme.style';
import {
  spacing8,
  spacing24,
  spacing12,
} from 'approot/shared/styles/spacing.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { RichtextEditor } from 'approot/shared/richtext/richtext.style';
import {
  getBackgroundColour,
  getBorderColour,
  getFieldHeight,
} from './response.utils';

type ResponseFieldProps = {
  $numberOflines: number;
  $baseHeight?: number | null;
  $baseColour?: string | null;
};

export const ResponseField = styled.div<ResponseFieldProps>`
  ${() =>
    useActivityBuilderFontStyles({
      isSmall: true,
    })}

  display: flex;
  align-items: center;
  flex-direction: column;

  ${RichtextEditor} {
    display: flex;
    min-height: ${props =>
      rem(getFieldHeight(props.$numberOflines, props.$baseHeight))};

    .ProseMirror {
      border: 1px solid ${grey5};
      border-radius: ${rem(borderRadius8)};
      ${({ $baseColour }) =>
        $baseColour &&
        `
        background-color: ${getBackgroundColour($baseColour)};
        border-color: ${getBorderColour($baseColour)};
      `}

      width: 100%;
      padding: ${({ $baseHeight }) =>
          $baseHeight === ACTIVITIES_BASE_HEIGHT_SMALL
            ? rem(spacing8)
            : rem(spacing8)}
        ${rem(spacing24)};

      ${({ $numberOflines }) =>
        $numberOflines === 1 &&
        `
          padding-top: ${rem(spacing12)};
        `};
    }
  }
`;

type ResponseProps = {
  variant: InquisitiveBorderStyle;
};
export const ResponseBox = styled.div<ResponseProps>`
  background-color: ${grey2};
  position: relative;
`;

type ResponseViewContainerProps = {
  $maxWidth?: number;
};
export const ResponseViewContainer = styled.div<ResponseViewContainerProps>`
  display: flex;
  flex-direction: column;
  gap: ${rem(spacing8)};

  ${({ $maxWidth }) =>
    $maxWidth &&
    `
      max-width: ${rem($maxWidth)};
      margin: auto;
    `}
`;

export const ResponseFieldWrapper = styled.div`
  position: relative;
`;
